import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, excluirFichaCadastral } from './types';

export const INITIAL_STATE: excluirFichaCadastral = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): excluirFichaCadastral {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_FICHA_CADASTRAL_REQUEST: {
				break;
			}

			case Types.EXCLUIR_FICHA_CADASTRAL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_FICHA_CADASTRAL_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_FICHA_CADASTRAL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
